<template>
  <div>
    <div class="head-box">
      <h4>意见反馈</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入用户/手机号/内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增</el-button>
        <el-button
          v-if="osg.has(`Suggest,export`)"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-in:state|array-integer#and': '0,1',
                beanName: 'suggest',
                title: '意见反馈'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="osg.has('Suggest,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    查看/回复
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="意见反馈" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doReply()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'suggest',
  data() {
    window.$this = this;
    return {
      name: 'suggest',
      fpi: {},
      formData: {},
      searchValue: '',
      openDetail: false,
      extFields: [],
      extField: {},
      options: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 10
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('suggest', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.formData = { exts: {} };
      this.openDetail = false;
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:userName|string#or': this.searchValue,
        'regex:content|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        'regex:contentPhone|string#or': this.searchValue,
        'is:state|integer#and': 1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('suggest/query.do', params, res => {
        this.$util.renderExtFields(this.extFields, res.data);
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.$util.renderExtField(this.extFields, row);
      row.contentImgs = row.contentImgs || [];
      for (let i = 0; i < row.contentImgs.length; i++) {
        let item = row.contentImgs[i];
        if (typeof item == 'string') {
          row.contentImgs[i] = {
            url: item,
            response: {
              key: item.split('/')[item.split('/').length - 1]
            }
          };
        }
      }
      console.log(row.contentImgs);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      let params = this.$util.deepCopy(this.formData);
      this.$util.saveExtField(this.extFields, params);
      params.contentImgs = params.contentImgs || [];

      for (let i = 0; i < params.contentImgs.length; i++) {
        if (params.contentImgs[i].constructor === Object) {
          params.contentImgs[i] =
            this.osg.downloadUrl +
            (params.contentImgs[i].response && params.contentImgs[i].response.key);
        }
      }
      console.log(params.contentImgs);

      if (this.osg.validate()) {
        this.osg.ajax('suggest/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doReply() {
      if (this.osg.validate()) {
        this.osg.ajax(
          'suggest/reply.do',
          { id: this.formData._id, memo: this.formData.memo },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    }
  }
};
</script>
